/**
 * src/utils/whatsapp.ts
 * 1-Click WhatsApp Reminder & Statement Dispatcher
 */

export interface WhatsAppReminderParams {
  name: string;
  amountOwed: number;
  creditorName?: string;
  upiId?: string;
  phone?: string;
}

export function generateWhatsAppReminderUrl({
  name,
  amountOwed,
  creditorName = 'CKAudit Central Ledger',
  upiId = 'chintankheradia123-1@okaxis',
  phone
}: WhatsAppReminderParams): string {
  const formattedAmount = `₹${Math.abs(amountOwed).toLocaleString('en-IN', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  })}`;

  const message = 
`👋 Hi ${name},

This is a friendly reminder regarding your pending ledger balance in *CKAudit*:

*Amount Due:* ${formattedAmount}
*Payable To:* ${creditorName}
*UPI ID:* ${upiId}

📲 *Quick Settle Link:*
upi://pay?pa=${upiId}&pn=CKAudit&am=${Math.abs(amountOwed).toFixed(2)}&cu=INR

Please settle at your convenience and upload the screenshot to the ledger for instant verification.

_Automated ledger dispatch via CKAudit_`;

  const encodedText = encodeURIComponent(message);
  
  if (phone && phone.trim()) {
    const cleanPhone = phone.replace(/[^0-9]/g, '');
    return `https://wa.me/${cleanPhone}?text=${encodedText}`;
  }

  return `https://api.whatsapp.com/send?text=${encodedText}`;
}

export function generateGroupSummaryWhatsAppUrl(stats: {
  totalReceived: number;
  totalPaid: number;
  netDelta: number;
  activeMembersCount: number;
}): string {
  const text =
`📊 *CKAudit — Executive Ledger Position*

• *Total Received:* ₹${stats.totalReceived.toLocaleString('en-IN', { minimumFractionDigits: 2 })}
• *Total Paid:* ₹${stats.totalPaid.toLocaleString('en-IN', { minimumFractionDigits: 2 })}
• *Net Position:* ₹${stats.netDelta.toLocaleString('en-IN', { minimumFractionDigits: 2 })}
• *Active Accounts:* ${stats.activeMembersCount}

_Verified Ledger Audit • Generated from CKAudit_`;

  return `https://api.whatsapp.com/send?text=${encodeURIComponent(text)}`;
}
